"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatekeeperNetwork = void 0;
var GatekeeperNetwork;
(function (GatekeeperNetwork) {
    GatekeeperNetwork["GENESIS"] = "genesis";
    GatekeeperNetwork["IGNITE"] = "ignite";
    GatekeeperNetwork["NILE"] = "nile";
    GatekeeperNetwork["BLUENILE"] = "blueNile";
    GatekeeperNetwork["MOSELLE"] = "moselle";
    GatekeeperNetwork["UNIQUENESS"] = "uniqueness";
})(GatekeeperNetwork = exports.GatekeeperNetwork || (exports.GatekeeperNetwork = {}));
